import axios from 'axios';

class AutoReplyService {
  static saveAutoReply(option) {
    return axios
      .post('/p/oneapp/client/api/setAutoResponse', option)
      .then(({ data }) => {
        if (data.code === 200) return true;
      });
  }
}

export default AutoReplyService;
